import "@/App.css";
import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { BrandingProvider } from "./context/BrandingContext";
import { PresenceProvider } from "./context/PresenceContext";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import ChatPage from "./pages/ChatPage";
import AdminPage from "./pages/AdminPage";
import ProfilePage from "./pages/ProfilePage";
import DirectoryPage from "./pages/DirectoryPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

function AppRoutes() {
    const { user } = useAuth();
    const authed = !!user && user !== false;
    return (
        <PresenceProvider enabled={authed}>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/reset-password" element={<ResetPasswordPage />} />
                    <Route path="/forgot-password" element={<ResetPasswordPage />} />
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <ChatPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/profile"
                        element={
                            <ProtectedRoute>
                                <ProfilePage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/directory"
                        element={
                            <ProtectedRoute>
                                <DirectoryPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute adminOnly>
                                <AdminPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </PresenceProvider>
    );
}

function App() {
    return (
        <BrandingProvider>
            <AuthProvider>
                <AppRoutes />
            </AuthProvider>
        </BrandingProvider>
    );
}

export default App;
